import type {ReactElement} from 'react';
import {HeaderSize, Panel, PanelContent, PanelHeader} from '@Components/panel';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import ClickableDiv from '@Components/clickable-div/clickable-div';
import styles from './email-media-options-panel.module.scss';
import type {EmailMediaOptionsPanelProps, MediaOptionTile} from './email-media-options-panel.types';

/** Media source chooser shown inside the email stock-media popup — replaces the "Select an option" modals on desktop. */
export function EmailMediaOptionsPanel(props: EmailMediaOptionsPanelProps): ReactElement {
  // content-ai clips its gradient to the glyph (background-clip: text), so the circle lives on a wrapper, not the icon.
  const renderTile = (tile: MediaOptionTile): ReactElement => {
    const aiClass = tile.isAi ? 'content-ai' : '';
    return (
      <ClickableDiv key={tile.icon} className={`${styles.tile} gap-1 spacing-p-4`} onClick={tile.onClick}>
        <div className={`${styles.tileIcon} spacing-p-2`}>
          <Icon icon={tile.icon} size={IconSize.SIZE_ICON_16} className={aiClass} />
        </div>
        <Text val={tile.label} size={TextSize.XSMALL} className={aiClass} />
      </ClickableDiv>
    );
  };

  return (
    <Panel
      panelHeader={
        <PanelHeader
          title={props.title}
          titleClasses="ct-neutral-primary"
          titleTextSize={TextSize.LG}
          backButtonIconSize={IconSize.SIZE_ICON_16}
          className="_borderless spacing-p-l-4 spacing-p-t-4 spacing-m-b-4"
          size={HeaderSize.SMALL}
          showCloseButton={false}
          showBackButton
          onBackButton={props.onBack}
        />
      }
      panelContent={<PanelContent className={`${styles.grid} gap-4 spacing-p-4`}>{props.tiles.map(renderTile)}</PanelContent>}
    />
  );
}
